import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { Helmet } from 'react-helmet'
import styled, { withTheme, css } from 'styled-components'
import { HomeButton } from '..'
import SearchInput from '../../containers/ESSearch/SearchInput'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { MoreHelpFooterContainer } from '../../containers'
import { useAppContext } from '../../containers/App/Context'
import { upperCaseFirstLetter } from '../../helpers/utils'

const v4 = css`
  --search-input-width: 300px;
  .button-group {
    margin-top: 0px;

    & > button {
      margin: 30px auto;
    }
    button {
      width: 210px;
      --button-height: 44px;
    }

    .inverted {
      --black: #000;
      --clr-btn: var(--white);
      --clr-text-on-button: var(--black);
      border: 1px solid var(--clr-text-on-button);
    }

    span {
      font-weight: 400;
      font-size: var(--h5);
    }
  }
  .search-group {
    h1 {
        --black: #000;
    }
    h1:first-letter {
        text-transform: uppercase;
    }
    form {
        margin: 30px auto;
    }
  }
`

const HomeContainer = styled.div.attrs(() => ({
  className: 'animated fadeIn'
}))`
  text-align: center;
  margin: 0 auto;

  .input-group {
    margin: 0 auto;
    z-index: 0;
    width: 100%;
  }
  .button-group {
    margin-top: 75px;

    & > button {
      margin: 75px auto 30px auto;
    }

    span {
      color: var(--clr-home-text-to-text);
      font-weight: 700;
      font-size: var(--h5);
    }

    a:hover,
    a:focus {
      text-decoration: none;
    }
  }
  .search-group {
    margin-top: 1rem;
    color: ${props =>
      props.theme.getOption('moreHelpFooter.textColor', '#000000')};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
      font-size: var(--h1);
      font-weight: 700;
      color: var(--clr-home-text-to-white);
    }
    p {
      color: var(--clr-home-text-to-text);
      font-size: 1.2rem;
    }
  }
  ${props => props.version === 'v4' && v4}
`
const HomeLink = styled(Link)`
  margin-top: 30px;
`

const Home = ({
  expressCategories,
  query,
  language,
  toggleSearchModal,
  toggleDeviceModal,
  devices,
  theme
}) => {
  const { versionKey: version } = useAppContext()
  const translated = messages[language]
  const titleOverride = {
    support: theme.getOption('header.titleOverride.support', translated.title),
    support2: theme.getOption(
      'header.titleOverride.support2',
      translated.subtitle
    )
  }
  const title = titleOverride.support
  const subtitle = titleOverride.support2

  return (
    <HomeContainer version={version}>
      <Helmet>
        <html lang={language} />
        <title>{title}</title>
        <link
          rel="canonical"
          href={`${window.location.origin}${
            language !== 'en' ? `?lang=${language}` : ''
          }`}
        />
      </Helmet>
      <div className="search-group">

        {version === 'v4' ? ( <h1>{upperCaseFirstLetter(title)}</h1>) :  (<h1>{title}</h1>)}
        <p>{subtitle}</p>
        <SearchInput toggleSearchModal={toggleSearchModal} />
      </div>
      <div className="button-group">
        <span>{translated.or}</span>
        <If condition={devices.length > 0}>
          <HomeButton  tabIndex="0" onClick={() => toggleDeviceModal()}>
            {theme.getOption(
              'home.devicesButtonText',
              translated.producttrigger
            )}
          </HomeButton>
        </If>
        <If condition={expressCategories.length > 0}>
          <HomeLink tabIndex="0" to={{ pathname: '/expresshelp', query }}>
            <HomeButton className="inverted">
              {theme.getOption(
                'home.popularFaqsButtonText',
                translated.faqtrigger
              )}
            </HomeButton>
          </HomeLink>
        </If>
      </div>
      <MoreHelpFooterContainer />
    </HomeContainer>
  )
}

Home.propTypes = {
  expressCategories: PropTypes.arrayOf(
    PropTypes.shape({
      accadLink: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.string
    })
  ).isRequired,
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      customerID: PropTypes.string,
      id: PropTypes.number,
      image_location: PropTypes.string,
      manufacturer: PropTypes.string,
      name: PropTypes.string,
      name_pretty: PropTypes.string,
      os: PropTypes.string
    })
  ).isRequired,
  theme: PropTypes.shape({
    getOption: PropTypes.func.isRequired
  }).isRequired,
  query: PropTypes.shape({}).isRequired,
  language: PropTypes.string.isRequired,
  toggleSearchModal: PropTypes.func.isRequired,
  toggleDeviceModal: PropTypes.func.isRequired,
  popularFaqsButtonText: PropTypes.string
}

export default LanguageProvider(withTheme(Home))



// WEBPACK FOOTER //
// ./src/components/Home/index.js